import { Control, ControllerProps, FieldValues, Path } from "react-hook-form";
import { SelectProps } from "@mui/material/Select";
import { TextFieldProps } from "@mui/material/TextField";

import FormSelect, {
  FormSelectOption,
} from "../../../../components/reusable-components/form/FormSelect";
import { MenuType } from "../../models/enums/MenuType";

const MenuTypeOptions: FormSelectOption[] = [
  { label: "Manual", value: MenuType.Manual },
  { label: "Silo", value: MenuType.Silo },
];

interface Props<T extends FieldValues = FieldValues> {
  name: Path<T>;
  control: Control<T>;
  disabled?: boolean;
  controllerProps?: Partial<Omit<ControllerProps<T, Path<T>>, "render">>;
  selectProps?: Partial<SelectProps>;
}

const MenuTypeSelect = <T extends FieldValues = FieldValues>({
  name,
  control,
  disabled = false,
  controllerProps,
  selectProps,
}: Props<T>) => (
  <FormSelect<T>
    name={name}
    control={control}
    label="Menu Type"
    options={MenuTypeOptions}
    controllerProps={controllerProps}
    selectProps={{ disabled, ...selectProps }}
  />
);

export default MenuTypeSelect;
